import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  ADDRESS_MAX_COUNT: 20,

  ADDRESS_FROM_PAGE_TYPE_DEFAULT: 0, //默认
  ADDRESS_FROM_PAGE_TYPE_ORDER: 1, //从订单页进入
  ADDRESS_FROM_PAGE_TYPE_POIPICKER: 2, //从定位地址页进入

}, km({
  ADDRESS_GET_LIST_SUCCESS: null,
  ADDRESS_GET_LIST_ERROR: null,
  ADDRESS_GET_LIST_ERROR_EMPTY: null,
  ADDRESS_GETDEFAULTADDRESS_SUCCESS: null,
  ADDRESS_GETDEFAULTADDRESS_ERROR: null,
  ADDRESS_ADDADDRESS_SUCCESS: null,
  ADDRESS_ADDADDRESS_ERROR: null,
  ADDRESS_UPDATEADDRESS_SUCCESS: null,
  ADDRESS_UPDATEADDRESS_ERROR: null,
  ADDRESS_DELETEADDRESS_SUCCESS: null,
  ADDRESS_DELETEADDRESS_ERROR: null,
  ADDRESS_CHANGEDEFAULTADDRESS_SUCCESS: null,
  ADDRESS_CHANGEDEFAULTADDRESS_ERROR: null,
  ADDRESS_GETEXPRESSRESOLVEADDRESS_SUCCESS: null,
  ADDRESS_GETEXPRESSRESOLVEADDRESS_ERROR: null,


  ADDRESS_SET_IS_SEARCH: null, //定位地址搜索页是否激活

  ADDRESS_GET_CENTER_SUCCESS: null, //拖拽地图中心点地址
  ADDRESS_GET_CENTER_ERROR: null,

  /*yeoman-template-point-1*/
}))
